import React from "react";
import i18next from "i18next";
import { ComponentMountCycle } from "widgets-for-react";
import { addWindowEvents, removeWindowEvents } from "../../utils/windowEvents";

function closeShareLayout() {
  const dialog:HTMLElement | null = document.querySelector('#a11y-sharing');
  const button:HTMLElement | null = document.querySelector('#a11y-sharing-toggle');
  if((dialog == null || button == null)) { return; }
  dialog.removeAttribute("open");
  button.focus();
}

export const SharingLayout = {
  Wrap: (props: { children?: React.ReactNode }): JSX.Element => {
    const { children } = props

    return (
      <div className="sharing">
        <div className="sharing__inner ls-container ls-gutter">
          {children}
        </div>
      </div>
    )
  },
  Button: (props: {
  }): JSX.Element => {
    return (
      <button id="a11y-sharing-toggle" className="link link--icon" onClick={(e) => {
        const dialog:HTMLElement | null = document.querySelector('#a11y-sharing');
        if(dialog == null) { return; }
        dialog.setAttribute("open", "");
        dialog.focus();
      }}>
        <span className="link__label">{i18next.t("General:ShareTitle")}</span>
        <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--share"></use></svg>
      </button>
    )
  },
  Popup: (props: {
  }): JSX.Element => {    
    return (
      <ComponentMountCycle onMount={() => { addWindowEvents({type: 'popup', callback: closeShareLayout})}} onUnmount={() => removeWindowEvents({type: 'popup', callback: closeShareLayout})}>
        <button className="skip-link" onClick={(e) => closeShareLayout()} onBlur={(e) => { if(document.querySelector(`#a11y-sharing:focus-within`) == null) { closeShareLayout() } }}>{i18next.t("General:ShareCloseSRT")}</button>
        <dialog id="a11y-sharing" className="popup sharing__popup rs_skip" aria-labelledby="a11y-sharing-title" tabIndex={0}>
          <div className="popup__inner sharing__popup-inner ls-spacing ls-gutter">
            <div className="popup__box sharing__box">
              <p id="a11y-sharing-title" className="popup__title sharing__title title--s">{i18next.t("General:ShareTitle")}</p>

              <p className="sharing__subtitle title--xs">{i18next.t("General:ShareCopyTitle")}</p>
              <div className="sharing__link">
                <p className="sharing__link-label">{window.location.href}</p>
                <svg className="sharing__link-icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--link"></use></svg>
              </div>

              <p className="sharing__subtitle title--xs">{i18next.t("General:ShareSubtitle")}</p>
              <SharingLayout.ShareItems />

              <button
                className="popup__close sharing__close"
                onClick={(e) => closeShareLayout()}
                onBlur={(e) => { if(document.querySelector(`#a11y-sharing:focus-within`) == null) { closeShareLayout() } }}
              >
                <span className="sr-text">{i18next.t("General:ShareCloseSRT")}</span>
                <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--close"></use></svg>
              </button>
            </div>
          </div>
          <div className="popup__overlay sharing__overlay" aria-hidden="true" onClick={(e) => closeShareLayout()}/>
        </dialog>
      </ComponentMountCycle>
    )
  },
  ShareItems: (props: {
  }): JSX.Element => {
    const pageTitleEL:HTMLElement| null = document.querySelector('.ph__title');
    const pageIntroEL:HTMLElement| null = document.querySelector('.ph__intro');
    const pageTitle: string = pageTitleEL != null ? pageTitleEL.innerHTML : '';
    const pageIntro: string = pageIntroEL != null ? pageIntroEL.innerHTML : '';
    return (
      <ul className='sharing__items'>
        <li className='sharing__item'>
          <a target="_blank" rel='noopener noreferrer' title={i18next.t('General:ShareFacebook')}  className="sharing__itemlink" href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}>
            <span className="sr-text">{i18next.t('General:ShareFacebookSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--facebook' /></svg>
          </a>
        </li>

        {/* <li className='sharing__item'>
          <a target="_blank" rel='noopener noreferrer' title={i18next.t('General:ShareInstagram')}  className="sharing__itemlink" href={``}>
            <span className="sr-text">{i18next.t('General:ShareInstagramSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--instagram' /></svg>
          </a>
        </li> */}

        <li className='sharing__item'>
          <a target="_blank" rel='noopener noreferrer' title={i18next.t('General:SharX')}  className="sharing__itemlink" href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(pageTitle)}&amp;url=${encodeURIComponent(window.location.href)}`}>
            <span className="sr-text">{i18next.t('General:ShareXSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--x' /></svg>
          </a>
        </li>

        <li className='sharing__item'>
          <a target="_blank" rel='noopener noreferrer' title={i18next.t('General:ShareLinkedin')}  className="sharing__itemlink" href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(pageTitle)}&summary=${encodeURIComponent(pageIntro)}&source=${encodeURIComponent(window.location.origin)}`}>
            <span className="sr-text">{i18next.t('General:ShareLinkedInSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--linkedin' /></svg>
          </a>
        </li>

        <li className='sharing__item'>
          <a target="_blank" rel='noopener noreferrer' title={i18next.t('General:ShareWhatsApp')}  className="sharing__itemlink" href={`whatsapp://send?text=${encodeURIComponent(pageTitle)}%20${encodeURIComponent(window.location.href)}`}>
            <span className="sr-text">{i18next.t('General:ShareWhatsAppSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--whatsapp' /></svg>
          </a>
        </li>

        <li className='sharing__item'>
          <a  target="_blank" rel='noopener noreferrer'title={i18next.t('General:ShareMail')} className="sharing__itemlink" href={`mailto:?subject=${encodeURIComponent(pageTitle)}&amp;body=${encodeURIComponent(pageTitle)}%20${encodeURIComponent(window.location.href)}`}>
            <span className="sr-text">{i18next.t('General:ShareMailSRT')}</span>
            <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref='#icon--mail' /></svg>
          </a>
        </li>
      </ul>
    )
  }
}
